import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Biggen } from "../directives/biggen";
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";
import { RouterLink } from "@angular/router";
import { paulineData } from "../data/paulineCorpus";

@Component({
  selector: 'app-stylometry',
  imports: [Biggen, Link, RouterLink],
  templateUrl: './stylometry.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './stylometry.scss',
})
export class Stylometry {
  dynamicTitle = inject(TitleChange);
  paulInfo = paulineData;
  
  constructor() {
    this.dynamicTitle.title(`Stylometry`);
    this.dynamicTitle.description(`Stylometric analysis of the gospels has revealed that they contain a mixture of different writing styles and sources.`);
  }
}
